import { jsx as _jsx } from "react/jsx-runtime";
import { ExternalLink, Text, Heading } from "@sundae/ui-toolkit";
import ReactMarkdown from "react-markdown";
export const ProposalDescription = ({ description }) => {
    return (_jsx(ReactMarkdown
    // TODO: new lines `\n` are not working rn - still needs to be implemented
    , { 
        // TODO: new lines `\n` are not working rn - still needs to be implemented
        children: description, components: {
            a: ({ style, ...props }) => (_jsx(ExternalLink, { ...props, className: "mb-4", variant: "primary" })),
            p: ({ style, ...props }) => _jsx(Text, { ...props, className: "mb-4", tag: "p" }),
            h1: ({ style, ...props }) => (_jsx(Heading, { ...props, className: "mb-4", tag: "h1", size: "2xl" })),
            h2: ({ style, ...props }) => (_jsx(Text, { ...props, className: "mb-4", tag: "h2", size: "xl", weight: "bold" })),
            h3: ({ style, ...props }) => (_jsx(Text, { ...props, className: "mb-4", tag: "h3", size: "lg", weight: "bold" })),
            h4: ({ style, ...props }) => (_jsx(Text, { ...props, className: "mb-4", tag: "h4", size: "base", weight: "bold" })),
            h5: ({ style, ...props }) => (_jsx(Text, { ...props, className: "mb-4", tag: "h5", size: "sm", weight: "bold" })),
            h6: ({ style, ...props }) => (_jsx(Text, { ...props, className: "mb-4", tag: "h6", size: "xs", weight: "bold" })),
            ul: ({ style, ...props }) => (_jsx("ul", { ...props, className: "list-disc ml-10" }))
        } }));
};
export default ProposalDescription;
//# sourceMappingURL=ProposalDescription.js.map